declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Pushes data to the Google Tag Manager dataLayer safely.
 */
export const pushToDataLayer = (data: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};
